import _ from "lodash";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  FormControl as MuiFormControl,
  InputLabel,
  Box,
  useMediaQuery,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import TextInput from "../toolkit/TextInput";
import Select from "../toolkit/Select";
import RadioButtons from "../toolkit/RadioButtons";
import CheckboxGroup from "../toolkit/CheckboxGroup";
import theme from "../themes/baseTheme";
import "../styles/FormControl.css";
import ErrorIcon from "@mui/icons-material/Error";
import Number from "../toolkit/Number";
// import Button from "../toolkit/Button";
import { Button } from "@mui/material";
import Enum from "../utils/Enums";

import FinancialData from "../pages/financialanalytics/FinancialData/FinancialData";
import axios from "../utils/fvAxios";
import { useNavigate } from "react-router-dom";

import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import { ToastContainer, toast } from "react-toastify";
import { Stack } from "@mui/system";
import MaskedTextField from "./MaskedTextField";
import { useTranslation } from "react-i18next";
import { getOrgType } from "../utils/Token";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FormControl({
  fieldId,
  label,
  inputType,
  items,
  labelPositioning = "vertical",
  fieldPositioning,
  disabled,
  placeHolder,
  bgClassName,
  buttonTypeReferenceValue,
  Pqid,
  Triger,
  reset,
  checked,
  SAVE,
  languageId,
  TableReferenceField,
  TableReference,
  TableRefFieldValueDisplay,
  Reference,
  hasUnsavedChanges,
  setValidate,
  isInsideChecklist,
  propwidth,
  // setRequired,
  isSelectAll,
  PQCLIENTID: clientId,
  editAccess,
  VIEWMODE,
  isLinked,
  isTrue,
  isBold,
  ...props
}) {
  labelPositioning = labelPositioning === "vertical" ? "column" : "row";
  const largeScreen = useMediaQuery(theme.breakpoints.up("sm"));
  if (!largeScreen || isInsideChecklist) labelPositioning = "column";

  const [selectOptions, setSelectOptions] = useState([]);
  // const navigate = useNavigate();
  useEffect(() => {
    if (inputType === "select") {
      if (Reference) {
        let whereExp = "";
        if (
          Reference?.qcTableReference == "BiddingInterests" ||
          Reference?.qcTableReference == "ClaycoBiddingInterests"
        ) {
          whereExp = "&whereExp=Status=1" +
            "&languageId=" +
            languageId
        }
        else if (Reference?.qcTableReference == "ClientContractTypes") {
          whereExp = `&whereExp=clientId=${clientId}`
        }

        axios
          .get(
            "/Prequalification/TableReferenceFieldOptions?tableReference=" +
            TableReference +
            "&tableReferenceField=" +
            TableReferenceField +
            "&tableRefFieldValueDisplay=" +
            TableRefFieldValueDisplay +
            whereExp
          )
          .then((res) => {
            setSelectOptions(
              res?.data?.data?.map((r) => ({ value: r?.value, text: r?.key }))
            );
          });
      } else {
        const selectOptions = (items || [])?.map(
          ({ id, value, text, headding }) => ({
            value: value || id,
            text,
            headding,
          })
        );
        setSelectOptions(selectOptions);
      }
    }
  }, [items, inputType]); //, props.value

  const [error, setError] = useState();
  const [trg, setTrg] = useState(true);

  function handleChange(arg) {
    props?.handleChange?.(
      ["select"]?.includes(inputType)
        ? arg
        : ["checkbox"]?.includes(inputType)
          ? arg?.target?.checked == true
            ? "true"
            : "false"
          : inputType === "tel"
            ? arg
            : arg?.target?.value
    );
    validateFileds(arg);
  }

  const handleBlur = (arg) => {
    setTimeout(() => {
      validateFileds(arg);
    }, 100);
  };

  const validateFileds = (argument) => {
    const isEmpty = (value) =>
      value === null || value === undefined || value === "" || (typeof value === 'string' && value?.trim() === '');
    const hasNonEmptyValue = (array) => array?.some((item) => !isEmpty(item));
    //let regEmail = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i;
  const regEmail = /^[a-zA-Z0-9_%+-]+(?:\.[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,20}$/;

    let regphone = /^\(\d{3}\) \d{3}-\d{4}$/;
    let empty = /[^ ]/;

    if (props.required) {
      if (inputType === "select") {
        if (argument === "None") argument = "";
        if (argument === "" || argument?.length === 0) {
          setError("This field is required");
          setValidate != undefined && setValidate(fieldId, argument, props?.required);
        } else if (
          typeof argument == Array &&
          argument?.length > 0 &&
          !hasNonEmptyValue(argument)
        ) {
          setError("This field is required");
          setValidate != undefined && setValidate(fieldId, argument, props?.required);
        } else {
          setError("");
          setValidate(fieldId, argument, props?.required);
        }
      } else if (inputType === "checkbox") {
        if (argument?.target?.checked) {
          setError("");
          setValidate != undefined && setValidate(fieldId, argument?.target?.checked, props?.required);
        } else {
          setError("This field is required");
          setValidate != undefined && setValidate(fieldId, argument?.target?.checked, props?.required);
        }
      } else if (inputType === "tel") {
        if (argument == "" || argument == "(___) ___-____") {
          setError("This field is required");
          setValidate != undefined && setValidate(fieldId, argument, props?.required);
        } else if (!regphone?.test(argument)) {
          setError("Invalid format. Use like (000) 000-0000");
          setValidate != undefined && setValidate(fieldId, argument, props?.required);
        } else {
          setError("");
          setValidate != undefined && setValidate(fieldId, argument, props?.required);
        }
      } else {
        if (
          argument?.target?.value?.length === 0 ||
          !empty?.test(argument?.target?.value)
        ) {
          setError("This field is required");
          setValidate != undefined && setValidate(fieldId, argument?.target?.value, props?.required);
        } else if (
          argument?.target?.value?.length !== 0 &&
          inputType === "email" &&
          !regEmail?.test(argument?.target?.value)
        ) {
          setError("Invalid Email Address");
          setValidate != undefined && setValidate(fieldId, argument?.target?.value, props?.required);
        } else {
          setError("");
          setValidate != undefined && setValidate(fieldId, argument?.target?.value, props?.required);
        }
      }
    } else {
      if (
        inputType === "email" &&
        argument?.target?.value?.length !== 0 &&
        !regEmail.test(argument?.target?.value)
      ) {
        setError("Invalid Email Address");
        setValidate != undefined && setValidate(fieldId, argument?.target?.value, props?.required);
      } else if (inputType === "tel") {
        if (argument && !regphone?.test(argument)) {
          setError("Invalid format. Use like (000) 000-0000");
          setValidate != undefined && setValidate(fieldId, argument, props?.required);
        } else {
          setError("");
          setValidate != undefined && setValidate(
            fieldId,
            argument?.target ? argument?.target?.value : argument,
            props?.required
          );
        }
      } else if (inputType === "select") {
        if (argument === "None") argument = "";
        setValidate != undefined && setValidate(fieldId, argument, props?.required);
      } else {
        setError("");
        setValidate != undefined && setValidate(
          fieldId,
          argument?.target ? argument?.target?.value : argument,
          props?.required
        );
      }
    }
  };

  useEffect(() => {
    setError("");
  }, [reset]);

  const [view, setView] = useState(true);
  const Viewed = () => {
    Triger(view);
    setView((view) => !view);
  };

  const [open1, setOpen1] = useState(false);

  const handleClickOpen = () => {
    setOpen1(true);
  };

  const handleClose1 = () => {
    setOpen1(false);
  };
  const { t } = useTranslation();

  const handleDateKeyDown = (e) => {
    e.preventDefault();// Prevent manual date input
  };
  return (
    <>
      {/* <ToastContainer /> */}
      <Dialog
        fullScreen
        open={open1}
        onClose={handleClose1}
        TransitionComponent={Transition}
      >
        <FinancialData
          remote={Viewed}
          Pqid={Pqid}
          handleClose1={handleClose1}
        />
      </Dialog>
      <div questionId={fieldId}>
        <MuiFormControl
          className={`form-control ${labelPositioning} ${fieldPositioning} ${bgClassName} ${inputType === "checkbox" && "checkbox-group"
            }`}
          disabled={disabled}
          sx={{ flexDirection: labelPositioning, display: !view ? "none" : "" }} //TODO:-we add display
          component={inputType === "checkbox" ? "fieldset" : undefined}
        >
          {label ? (
            <Box className="label-container">
              <InputLabel
                className={`input-label ${props?.isBold ? "font-weight-bold" : ""
                  } `}
                sx={{ color: "black" }}
              >
                <span style={{ fontWeight: isBold == true ? "bold" : "" }}>{label}</span>

                <span
                  style={{ color: props?.color }}
                  hidden={props?.color != "Red" || props?.heighlight == "false"}
                >
                  {" "}
                  <ErrorIcon sx={{ fontSize: "medium" }} />
                </span>
                {props?.required && <sup>*</sup>}
              </InputLabel>
            </Box>)
            :
            <Box className="label-container">
              <InputLabel
                className={`input-label mb-0 ${props.isBold ? "font-weight-bold" : ""
                  } `}
                sx={{ color: "black" }}
              >
                <span
                  style={{ color: props?.color }}
                  hidden={props?.color != "Red" || props?.heighlight == "false"}
                >
                  <ErrorIcon sx={{ fontSize: "medium" }} />
                </span>
                {props?.required && <sup>*</sup>}
              </InputLabel>
            </Box>
          }

          {isLinked ? <InputLabel className="text-wrap rounded" sx={{ color: "black" }}>
            <span>{props?.value ? props?.value : "No Data"}</span>
            {/* <span>{props?.value ?props?.value : "No Data"}                
                
                {(props?.value+"").toLowerCase()=="true"?<CheckBoxIcon style={{color:"green"}}/>:<CancelIcon style={{color:"red"}}/>}

                </span> */}
          </InputLabel>
            : (getOrgType() == "Admin" ? (VIEWMODE == false || editAccess == false) : (getOrgType() == "Vendor" || getOrgType() == "Client" ? editAccess == false : (VIEWMODE == false || editAccess == false))) ? (
              <p className="Mui-disabled MuiInputBase-root css-1wigrfo label-ctrl w-50"> {
                inputType === "select" ? Array.isArray(props?.value)
                  ? props?.value?.filter((value) => value !== "")?.map((val) => selectOptions?.find((x) => x.value === val)?.text ?? val)
                    .join(", ")
                  : inputType === "select" ? selectOptions?.find((x) => x.value === props?.value)?.text ?? props?.value
                    : props?.value : inputType === "date" && props?.value && !isNaN(new Date(props?.value).getTime())
                  ? new Date(props?.value)?.toLocaleDateString("en-US")
                  : inputType === "number" ? props?.value : props?.value}
                {/*   :inputType === "number" ? parseFloat(props.value).toFixed(2) : props.value}   */}
              </p>

            ) : (
              <Box sx={{ width: "auto" }}>
                {" "}
                {/* Width add by mahesh */}
                {["text", "password"]?.includes(inputType) ? (
                  <TextInput
                    placeholder={placeHolder}
                    type={inputType}
                    {...props}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                  />
                ) : inputType === "select" ? (
                  <Select
                    IsSelectAll={isSelectAll}
                    style={{ marginTop: isInsideChecklist ? "0" : "0" }}
                    items={selectOptions}
                    Propwidth={propwidth}
                    {...props}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                  />
                ) : inputType === "radio" ? (
                  <RadioButtons
                    name={fieldId}
                    items={items}
                    {...props}
                    direction={fieldPositioning}
                    handleChange={handleChange}
                  />
                ) : inputType === "button" ? (
                  <>
                    {buttonTypeReferenceValue ==
                      Enum?.ButtonRefType?.FinancialAnalytics ? (
                      <Button
                        variant="text"
                        disabled={disabled}
                        onClick={handleClickOpen}
                        sx={{ textTransform: "capitalize" }}
                      >
                        {items[0]?.text}
                        {"->"}
                      </Button>
                    ) : (
                      <Button
                        variant="text"
                        disabled={disabled}
                        sx={{ textTransform: "capitalize" }}
                        onClick={() => SAVE("1")}
                      >
                        {items[0]?.text}
                        {"->"}
                      </Button>
                    )}
                  </>
                ) : inputType === "checkbox" ? (
                  // <CheckboxGroup
                  //   name={fieldId}
                  //   items={items}
                  //   {...props}
                  //   disabled={disabled}
                  //   direction={fieldPositioning}
                  //   handleChange={handleChange}
                  // />

                  <FormControlLabel
                    className="d-flex align-items-start form-control-checkbox-label"
                    control={
                      <Checkbox
                        name={fieldId}
                        // {...props}
                        checked={checked}
                        size="small"
                        onChange={handleChange}
                      />
                    }
                    label={items?.map((r) => r?.text)?.join("|")}
                  />
                ) : inputType === "textarea" ? (
                  <TextInput
                    type={inputType}
                    multiline
                    rows={3}
                    {...props}
                    handleChange={handleChange}
                    placeholder={placeHolder}
                    handleBlur={handleBlur}
                  />
                ) : // : inputType === "number" ? (
                  //   <Number
                  //     // name={fieldId}
                  //     // value={value}
                  //     name={fieldId}
                  //     items={items}

                  //     type={inputType}
                  //     {...props}
                  //     handleChange={handleChange}
                  //   />

                  // )
                  inputType === "label" ? (
                    <TextInput
                      ISTRUE={isTrue}
                      type="label"
                      {...props}
                      handleChange={() => { }}
                      disabled={true}
                      className={`${props?.className || ""} label-ctrl`}
                    />
                  ) : inputType === "none" ? (
                    <></>
                  ) : inputType === "tel" ? (
                    <MaskedTextField
                      mask="(999) 999-9999"
                      onChange={handleChange}
                      className="text-feild-custom"
                      size="small"
                      {...props}
                    />
                  ) : inputType === "number" ? (
                    <TextInput
                      type={inputType}
                      {...props}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                    /> //TODO :-- We add condation here
                  ) : inputType === "date" ? (
                    <TextInput
                      type={inputType}
                      {...props}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      handleKeyDown={handleDateKeyDown}
                    />
                  ) : (
                    <TextInput
                      type={inputType}
                      {...props}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                    /> //TODO :-- We add condation here
                  )}
                {error && <p className="text-danger">{error}</p>}
              </Box>
            )}
        </MuiFormControl>
      </div>
      {/* {!view && <FinancialData remote={Viewed} Pqid={Pqid} />} */}
    </>
  );
}

FormControl.propTypes = {
  /**
   * Label
   */
  label: PropTypes.string,
  /**
   * Label positioning relative to input box - vertical / horizontal
   */
  labelPositioning: PropTypes.string,
  /**
   *  Input type - text, number etc
   */
  inputType: PropTypes.string,
  /**
   * List of options if inputType is select or checkbox or radio
   */
  items: PropTypes.arrayOf(PropTypes.object),
};

FormControl.defaultProps = {
  inputType: "text",
  disabled: false,
};
